import PropTypes from "prop-types";

const contractInterface = {
  id: PropTypes.number,
  name: PropTypes.string,
  documentUrl: PropTypes.string,
  documentKey: PropTypes.string,
  isActive: PropTypes.bool,
  isDefault: PropTypes.bool,
  selected: PropTypes.bool,
  order: PropTypes.number,
  fields: PropTypes.array,
  pagesCount: PropTypes.number,
}
  //
  // [
  // {
  //   id: "doc1",
  //   name: "2025-Arizona-Agreement.pdf",
  //   documentUrl: "http://localhost:9005/#/1",
  //   documentKey: "",
  //   isActive: false,
  //   isDefault: true,
  //   selected: false,
  //   order: 1,
  //   fields: "",
  // },
  //   {
  //     id: "doc2",
  //     name: "2024-California-Agreement.pdf",
  //     documentUrl: "http://localhost:9005/#/2",
  //     documentKey: "",
  //     isActive: false,
  //     isDefault: false,
  //     selected: false,
  //     order: 2,
  //     fields: "",
  //   },
  //   {
  //     id: "doc3",
  //     name: "2022-Texas-Agreement.pdf",
  //     documentUrl: "http://localhost:9005/#/3",
  //     documentKey: "",
  //     isActive: false,
  //     isDefault: false,
  //     selected: false,
  //     order: 3,
  //     fields: "",
  //   },
  // ]

export default contractInterface;
